// extracted by mini-css-extract-plugin
export default {"item":"item--njj65","item__label":"item__label--b9Nmg","itemLabel":"item__label--b9Nmg"};